import { CaseColumn } from "@/types/caseColumns"
import { CaseUser } from "./caseUser"
import { DataType } from "./dataType"
import { Operator } from "./insights/operators"

interface UserColumn extends CaseColumn {
}

const userColumns: UserColumn[] = [
	{
		key: "name",
		label: "Name",
		dataType: "text",
		fieldDataType: DataType.string,
		dynamicField: false,
		sortable: true,
		operators: [Operator.Equals, Operator.NotEqual, Operator.Contains]
	},
	{
		key: "email",
		label: "Email",
		dataType: "text",
		fieldDataType: DataType.string,
		dynamicField: false,
		sortable: true,
		operators: [Operator.Equals, Operator.NotEqual, Operator.Contains]
	}] as UserColumn[]

export { UserColumn, userColumns }
